import {FC, useEffect, useMemo} from "react";
import Box from "../Box";
import SelectInput from "../UI/SelectInput";
import { ISelectOption } from "../UI/SelectInput/types";
import { Space } from "antd";
import dayjs from "dayjs";
import * as localeData from 'dayjs/plugin/localeData';
import 'dayjs/locale/bs';
import {sendSystemLog} from "../../context/AuthProvider/useAuth";

export type MonthYearProps = {
  month: string;
  year: string;
  years: ISelectOption[];
  onMonthChange: (month: string) => void;
  onYearChange: (year: string) => void;
};

const MonthYear: FC<MonthYearProps> = ({
  month,
  year,
  years,
  onMonthChange,
  onYearChange,
}) => {
  const monthOptions = useMemo(() => {
    return dayjs.localeData().months().map<ISelectOption>((month, index) => ({
      name: month,
      value: index.toString(),
    }));
  }, []);
  return (
    <Space direction="horizontal" size="small" wrap>
      <SelectInput
        label="Month"
        options={monthOptions}
        onSelectChange={onMonthChange}
        value={month}
        selectOnEnter={false}
      />
      <SelectInput
        label="Year"
        options={years}
        onSelectChange={onYearChange}
        value={year}
        selectOnEnter={false}
      />
    </Space>
  );
};

export default MonthYear;
